import React, { useContext, useRef, useState, useEffect } from 'react'
import { FormContext } from '../../FormContext';
import { determineIsDisabled, isFieldSigned } from './utils';

const TextArea = ({ field_column, field_id, field_label, field_placeholder, field_disabled_approver, field_mandatory, field_value, field_disabled, field_multiple_id ,field_multiple_type}) => {
  
  const { handleChangeInput, formChatPerson, formStatus, formPageType, formUserLock,formApprovalIndex,formMultipleType ,formOfficers} = useContext(FormContext);

  const textareaRef = useRef(null);
  const [value, setValue] = useState('');

  // let isSigned = field_id.startsWith("sign_");
  let isSigned = isFieldSigned(field_id,formMultipleType,formChatPerson,formOfficers,field_multiple_type);


  // const isDisabled = formUserLock ? true :formPageType === 'user'
  //   ? (field_multiple_id === "mapprover"
  //     ? (field_id.startsWith('user_approver_') || field_id.startsWith('user_action_')) && parseInt(field_id.slice(-1)) < formApprovalIndex
  //     : true)
  //   : field_disabled_approver === '1' || field_disabled || isSigned || (formStatus === 'Submitted' && (field_multiple_id === 'mapprover' || field_id.startsWith('user_approver_')));

  // const isDisabled = (formUserLock && formPageType== 'user') ? true:formPageType === 'user'
  // ? (field_multiple_id === "mapprover"
  //   ? (field_id.startsWith('user_approver_') || field_id.startsWith('user_action_')) && parseInt(field_id.slice(-1)) < formApprovalIndex
  //   : true)
  // : field_disabled_approver === '1' || field_disabled || isSigned || (formStatus === 'Submitted' && (field_multiple_id === 'mapprover' || field_id.startsWith('user_approver_')));

  const isDisabled = determineIsDisabled(
    formUserLock,
    formPageType,
    field_multiple_id,
    isSigned,
    field_id,
    formApprovalIndex,
    field_disabled_approver,
    field_disabled,
    formStatus
  );

  const textAreaChange = (event) => {
    setValue(event.target.value);
  };
  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = "auto";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [value]);
  return (
    <div className={`form-group ${field_column ? field_column : 'col-sm-12'}`}>
      <label>{field_label} <font color="red">{field_mandatory === 'yes' ? '*' : ''}</font></label>
      <textarea 
      ref={textareaRef}
      className="form-control" rows="3" placeholder={field_placeholder} value={field_value}
        name="field_value" onChange={event => {
          handleChangeInput(field_id, event);
          textAreaChange(event);

        }}
        
        disabled={isDisabled}

      ></textarea>
    </div>
  )
}

export default TextArea
